import { computed, onMounted, ref } from 'vue';
import { useSalesData } from './useSalesData';
import {
  SALES_LISTS,
  defaultSalesFilters,
  useSalesRouteState,
} from './useSalesRouteState';
import {
  RECENT_SALE_DESTINATIONS,
  recentSaleDestination,
} from './salesRecentNavigation';

export function useSalesDashboard({ route, router, t, notify, currentUser }) {
  const routeState = useSalesRouteState({ route, router });
  const data = useSalesData({ t, notify });
  const recentList = ref('rascunhos');
  const requestParams = computed(() => ({
    list: routeState.activeList.value,
    page: routeState.page.value,
    ...routeState.filters.value,
  }));

  const refresh = () =>
    Promise.all([
      data.loadList(requestParams.value),
      data.loadAddresses({ list: routeState.activeList.value }),
      data.loadDashboard({ recent_list: recentList.value }),
      data.loadPostSaleStatuses(),
    ]);
  const selectList = value => {
    routeState.activeSection.value = 'vendas';
    routeState.activeList.value = value;
    routeState.page.value = 1;
    routeState.syncIndex();
    data.loadList(requestParams.value);
    data.loadAddresses({ list: value });
  };
  const selectRecentList = value => {
    recentList.value = value;
    return data.loadDashboard({ recent_list: value }, true);
  };
  const selectSection = value => {
    routeState.activeSection.value = value;
    routeState.syncIndex();
  };
  const applyFilters = filters => {
    routeState.filters.value = { ...defaultSalesFilters(), ...filters };
    routeState.page.value = 1;
    routeState.syncIndex();
    data.loadList(requestParams.value);
  };
  const changePage = value => {
    routeState.page.value = Math.max(1, Math.min(value, data.totalPages.value));
    routeState.syncIndex();
    data.loadList(requestParams.value);
  };
  const openDetail = transaction => routeState.openDetail(transaction.id);
  const openRecent = transaction => {
    const destination = recentSaleDestination({
      transaction,
      currentUserId: currentUser?.value?.id,
    });

    if (destination === RECENT_SALE_DESTINATIONS.DELIVERY) {
      return routeState.openDelivery(transaction.id);
    }

    if (destination === RECENT_SALE_DESTINATIONS.REGISTRATION) {
      return routeState.openRegistration(transaction.id);
    }

    return openDetail(transaction);
  };
  const openSignatures = transaction =>
    routeState.openSignatures(transaction.id);

  onMounted(() => Promise.all([refresh(), data.loadAgents()]));

  return {
    ...data,
    ...routeState,
    applyFilters,
    changePage,
    clearFilters: () => applyFilters(defaultSalesFilters()),
    lists: SALES_LISTS,
    openDetail,
    openRecent,
    openSignatures,
    refresh,
    selectList,
    selectRecentList,
    selectSection,
  };
}
